import React from "react";
import {AppApi} from "../../../../utils/AppApi";
import {useAlert} from "../../../../utils/components/providers/AlertProvider";
import {Utils} from "../../../../utils/Utils";
import EditMemberRegions from "./EditMemberRegions";

export interface MemberRegion {
    regionId: string
    regionName: string
}

const initialRegion: MemberRegion = {
    regionId  : "",
    regionName: ""
}

export default function MemberRegions() {
    const {showMessage} = useAlert()
    const [regions, setRegions] = React.useState<MemberRegion[]>([])
    const [editData, setEditData] = React.useState({show: false, region: initialRegion})

    const getMemberRegions = () => {
        Utils.toggleSpinner('show')
        AppApi.getMemberRegions()
            .then(res => {
                Utils.toggleSpinner('hide')
                if (res.data.success) {
                    setRegions(res.data['regions'])
                }
            })
            .catch(() => {
                Utils.toggleSpinner('hide')
                showMessage({message: 'Error while loading member regions', type: 'error'})
            })
    }

    React.useEffect(() => {
        getMemberRegions()
    }, [])

    return (
        <>
            <div className={'action_container'}>
                <span className={'action_btn'} onClick={() => setEditData({region: initialRegion, show: true})}>Add New</span>
                <span className={'action_btn'} onClick={getMemberRegions}>Load List</span>
            </div>

            <div className="table-responsive">
                <table id="example" className="table table-striped w-100">
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th>Region Name</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            regions?.map((region: MemberRegion, index: number) =>
                                <tr key={region.regionId}>
                                    <td>{index + 1}</td>
                                    <td>{region.regionName}</td>
                                    <td>
                                        <span className={'action_btn'} onClick={() => setEditData({show: true, region: region})}>
                                            Edit
                                        </span>
                                        <span className={'action_btn'}>Delete</span>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>

            <EditMemberRegions
                show={editData.show} region={editData.region}
                close={(aRegion) => {
                    if (aRegion !== undefined) {
                        if (editData.region.regionId === "") {
                            setRegions([aRegion, ...regions])
                        } else {
                            setRegions(regions.map(bRegion =>
                                bRegion.regionId === aRegion.regionId ? aRegion : bRegion))
                        }
                    }
                    setEditData({region: initialRegion, show: false})
                }}/>
        </>
    )
}